import { trace } from '@opentelemetry/api';
import { WebTracerProvider, BatchSpanProcessor } from '@opentelemetry/sdk-trace-web';
import { registerInstrumentations } from '@opentelemetry/instrumentation';
import { OTLPTraceExporter } from '@opentelemetry/exporter-trace-otlp-http';
import { resourceFromAttributes } from '@opentelemetry/resources';
import { ATTR_SERVICE_NAME, ATTR_SERVICE_VERSION } from '@opentelemetry/semantic-conventions';
import { FetchInstrumentation } from '@opentelemetry/instrumentation-fetch';
import { XMLHttpRequestInstrumentation } from '@opentelemetry/instrumentation-xml-http-request';

const OTEL_ENDPOINT = window.__ROSTA_OTEL_ENDPOINT__ || '';
const SERVICE_NAME = 'rosta-web-ui';
const SERVICE_VERSION = import.meta.env.VITE_APP_VERSION || '0.1.0';

export function initTelemetry(): void {
  if (!OTEL_ENDPOINT) {
    console.log('OpenTelemetry disabled (no endpoint configured)');
    return;
  }
  const resource = resourceFromAttributes({
    [ATTR_SERVICE_NAME]: SERVICE_NAME,
    [ATTR_SERVICE_VERSION]: SERVICE_VERSION,
    'browser.userAgent': navigator.userAgent,
    'browser.language': navigator.language,
  });

  const exporter = new OTLPTraceExporter({
    url: `${OTEL_ENDPOINT}/v1/traces`,
  });

  const provider = new WebTracerProvider({
    resource,
    spanProcessors: [new BatchSpanProcessor(exporter, {
      maxQueueSize: 200,
      maxExportBatchSize: 100,
      scheduledDelayMillis: 5000,
      exportTimeoutMillis: 30000,
    })],
  });

  registerInstrumentations({
    tracerProvider: provider,
    instrumentations: [
      new FetchInstrumentation({
        ignoreUrls: [/\/health/, /\/ready/, /\/metrics/, /\.js$/, /\.css$/, /\.png$/, /\.ico$/],
      }),
      new XMLHttpRequestInstrumentation({
        ignoreUrls: [/\/health/, /\/ready/, /\/metrics/],
      }),
    ],
  });

  trace.setGlobalTracerProvider(provider);

  console.log(`OpenTelemetry initialized → ${OTEL_ENDPOINT} (service: ${SERVICE_NAME})`);
}

declare global {
  interface Window {
    __ROSTA_OTEL_ENDPOINT__?: string;
  }
}
